import { render, staticRenderFns } from "./Content6.vue?vue&type=template&id=ab4507e6&scoped=true"
import script from "./Content6.vue?vue&type=script&lang=js"
export * from "./Content6.vue?vue&type=script&lang=js"
import style0 from "./Content6.vue?vue&type=style&index=0&id=ab4507e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4507e6",
  null
  
)

export default component.exports